import { ENDPOINTS } from '../_config';

export const getIndustries = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_INDUSTRIES);
    const response = await request.json();

    return response;
  } catch (e) {
    return null;
  }
};

// JP #Task 41
export const getGlobalIndustries = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_GLOBAL_INDUSTRIES);
    const response = await request.json();

    return response;
  } catch (e) {
    return null;
  }
};
